import styled from 'styled-components';
import { Skeleton } from 'components';

export const AlertsContainer = styled.div.attrs({
  className: 'mt-3',
})``;

export const AlertsList = styled.div.attrs({
  className: 'flex flex-wrap gap-2',
})``;

export const AlertSkeletonIcon = styled(Skeleton).attrs({
  className: 'h-9 w-9 rounded-md',
})``;

export const ItemContainer = styled.div.attrs({
  className: 'flex items-center',
})``;

export const AlertSymbol = styled.div.attrs<{ $eligibleNow: boolean }>((props) => ({
  className: `flex-shrink-0 flex items-center justify-center h-6 w-6 rounded-sm text-white font-mono text-xs cursor-help relative ${
    props.$eligibleNow ? 'bg-danger' : 'bg-warning'
  }`,
}))<{ $eligibleNow: boolean }>``;

export const LabelStack = styled.span.attrs({
  className: 'flex flex-col items-center justify-center gap-px',
})``;

export const IconLabel = styled.span.attrs({
  className: 'text-[10px] font-semibold leading-none',
})``;

export const AlertYear = styled.span.attrs({
  className: 'text-[8px] leading-none',
})``;

// Most glyphs are tight artwork centered in the box; an icon drawn with its own box fills it.
export const AlertIcon = styled.img.attrs<{ $fillsBox?: boolean }>((props) => ({
  className: `${props.$fillsBox ? 'w-6 h-6' : 'w-4 h-4'} object-contain`,
}))<{ $fillsBox?: boolean }>``;

export const SegmentGroup = styled.span<{ $stacked: boolean }>`
  display: inline-flex;
  flex-direction: ${(props) => (props.$stacked ? 'column' : 'row')};
  align-items: center;
`;

const compositeRounding = (position: 'left' | 'right', stacked: boolean): string => {
  if (stacked) return position === 'left' ? 'rounded-t-sm' : 'rounded-b-sm';
  return position === 'left' ? 'rounded-l-sm' : 'rounded-r-sm';
};

export const CompositeSegment = styled.div.attrs<{
  $status: 'pending' | 'done';
  $position: 'left' | 'right';
  $stacked: boolean;
}>((props) => ({
  className: `flex-shrink-0 flex items-center justify-center h-6 w-6 text-white font-mono text-xs cursor-help ${compositeRounding(
    props.$position,
    props.$stacked
  )} ${props.$status === 'done' ? 'bg-success' : 'bg-danger'}`,
}))<{ $status: 'pending' | 'done'; $position: 'left' | 'right'; $stacked: boolean }>``;
